import React from 'react'
import styled from 'styled-components'
import { EventAvailable as AvailabilityIcon } from '@mui/icons-material'
import Plugin from './Plugin'

const Label = styled.label`
	cursor: pointer;
	margin: 0;
	color: #535353;
	font-size: 11px;
	margin-left: 4px;
	flex: 1;
`

const DivOptionRow = styled.div`
	cursor: pointer;
	display: flex;
	align-items: center;
	margin: 4px 0;
`

export default function AvailabilityPlugin({ availability, setAvailability, drawerOpen, setDrawerOpen, classes }) {

    return (
        <Plugin {...{
            drawerOpen,
            setDrawerOpen,
            classes,
            Icon: AvailabilityIcon,
            title: 'Availability'
        }}>
            <DivOptionRow onClick={e => setAvailability({ ...availability, inStockOnly: !availability.inStockOnly })}>
                <input
                    type="checkbox"
                    checked={availability?.inStockOnly || false}
                    onChange={e => setAvailability({ ...availability, inStockOnly: e.target.checked })}
                    style={{ cursor: 'pointer' }}
                    name='instock'
                />
                <Label htmlFor='instock'>In Stock Only</Label>
            </DivOptionRow>
        </Plugin>
    )
}